import Box from 'components/shared/Box'
import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'

export const SelfcareAccomodation = () => (
    <>
        <Box isFullWidth gap={[16, 24]}>
            <Text variant="heading3" color="secondary_700">
                <FormattedMessage
                    id="selfcare.accomodation.heading"
                    defaultMessage="Nocleg w Suntago Village"
                />
            </Text>
            <Info color="warning" hasNoBackground hasBorder>
                <Box gap={4}>
                    <Text variant="heading5" color="grayscale_900">
                        <FormattedMessage
                            id="selfcare.accomodation.title"
                            defaultMessage="Jak zarządzać noclegiem w Suntago Village?"
                        />
                    </Text>
                    <Text variant="bodySmall" color="grayscale_800">
                        <FormattedMessage
                            id="selfcare.accomodation.description"
                            defaultMessage="Jeśli chcesz zmienić lub anulować swój nocleg w Suntago Village, napisz na adres <link>rezerwacje.suntagovillage@parkofpoland.com</link> (nie później niż 14 dni przed rozpoczęciem pobytu)."
                            values={{
                                link: (chunks: string[]) => (
                                    <Text
                                        as="a"
                                        isUnderlined
                                        variant="bodySmall"
                                        href="mailto:rezerwacje.suntagovillage@parkofpoland.com"
                                        color="grayscale_800"
                                        style={{ wordBreak: 'break-word' }}
                                    >
                                        {chunks}
                                    </Text>
                                ),
                            }}
                        />
                    </Text>
                </Box>
            </Info>
        </Box>
    </>
)
